module.exports = __webpack_public_path__ + "img/powerplant.315df52.jpg";